import {
    ACCOUNTING_AREA_ID_MARKER,
    processRequestForAccountingAreaWithReplacement,
} from './network/managedRequestForAccountingArea';
import { API } from '../constants';
import { PbRequest } from './pbRequest';
import { PbDispatch } from './index';

export function OrderByMail(message: string) {
    return async (dispatch: PbDispatch) => {
        const request: RequestInit = {
            method: 'POST',
            body: JSON.stringify({ text: message }),
        };

        try {
            await processRequestForAccountingAreaWithReplacement(
                dispatch,
                `${API}/orders/by_mail/${ACCOUNTING_AREA_ID_MARKER}`,
                request,
                PbRequest.PLACE_ORDER_BY_MAIL
            );
        } catch {}
    };
}
